export function packageSnapshot(scope: string, time: string, cost: string): string {
  return `${scope}\n\nTime: ${time}\nCost: ${cost}`;
}
